<script setup lang="ts">
import { CmeProviders } from "~/enums/cme-providers.enums";

const props = defineProps<{
  visible: boolean;
}>();

const { course } = useCourseState();

const showDialog = ref<boolean>(props.visible);
watch(() => props.visible, () => {
  showDialog.value = props.visible;
});

defineEmits<{
  (e: 'dismiss'): void;
}>();
</script>

<template>
  <Dialog
    v-model:visible="showDialog"
    :draggable="false"
    modal
    header="Claim certificate"
    class="sm:w-[800px]"
    :pt="{
      content: {
        class: 'py-6 px-4 no-scrollbar'
      }
    }"
    @hide="$emit('dismiss')"
  >
    <CourseClaimCertificateDialogFormCMEConsultants
      v-if="course?.cmeProviderSlug === CmeProviders.CmeConsultants"
      @downloaded="$emit('dismiss')"
    />
    <CourseClaimCertificateDialogFormCMEOutfitters
      v-else-if="course?.cmeProviderSlug === CmeProviders.CmeOutfitters"
      @downloaded="$emit('dismiss')"
    />
  </Dialog>
</template>

<style scoped lang="scss">
@import "@mui/assets/styles/utility.scss";

.country-flag-icon {
  &--value {
    height: 0.7rem !important;
  }
  &--option {
    height: 0.8rem !important;
  }
}

.p-dropdown-panel {
  width: 100% !important;
}
</style>